var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.title)?_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }